/*
 * validate if function is a PublicEvent
 * The name of your validation function should match the event type it is validating
 * See PublicEvents enum for list of valid event types
 */
export var validators = {
/* Example usage:
 *
 * screen(event) {
 *  const exists = !!event.payload.requiredDataExample;
 *  !exists && logValidationWarning(event.eventName, errorMessages.missingRequiredDataExample);
 *
 *  return exists;
 * }
*/
};
export var logValidationWarning = function (eventName, message) {
    console.warn("[Public Analytics API] Error validating ".concat(eventName, " event: '").concat(message, "'"));
};
